import { Component } from '@theme/component';

/**
 * A session-based countdown shown in the cart drawer reservation banner.
 *
 * @typedef {object} CartReservationTimerRefs
 * @property {HTMLTimeElement} countdown
 * @extends Component<CartReservationTimerRefs>
 */
class CartReservationTimer extends Component {
  requiredRefs = ['countdown'];

  /** @type {number | undefined} */
  #interval;

  /** @type {number} */
  #deadline = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#deadline = this.#getDeadline();
    this.#render();
    this.#interval = window.setInterval(() => this.#render(), 1000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#interval) window.clearInterval(this.#interval);
  }

  #getDeadline() {
    const duration = Math.max(1, Number(this.dataset.durationMinutes) || 5) * 60 * 1000;
    const storageKey = this.dataset.storageKey || 'cart-reservation-deadline';
    const storedDeadline = Number(sessionStorage.getItem(storageKey));
    if (storedDeadline > Date.now()) return storedDeadline;

    const deadline = Date.now() + duration;
    sessionStorage.setItem(storageKey, String(deadline));
    return deadline;
  }

  #render() {
    const remaining = Math.max(0, this.#deadline - Date.now());
    const totalSeconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const text = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    this.refs.countdown.textContent = text;
    this.refs.countdown.dateTime = `PT${minutes}M${seconds}S`;

    if (remaining === 0 && this.#interval) {
      window.clearInterval(this.#interval);
      this.#interval = undefined;
    }
  }
}

if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', CartReservationTimer);
}
